export function notFound(message) {
  const error = new Error(message || 'Resource not found');
  error.status = 404;
  throw error;
}
